import styled from 'styled-components'
import { PopoverProps } from './interfaces'

export const Wrapper = styled.div`
  position: relative;
`

export const Anchor = styled.button`
  border: unset;
  background: unset;
  outline: 0;
`

export const Popover = styled.div<PopoverProps>`
  display: ${({ $isOpened }) => ($isOpened ? 'block' : 'none')};
  width: ${({ $width }) => $width || 'fit-content'};
  right: ${({ $width }) => ($width ? '0' : '56px')};
  background: ${({ theme }) => theme.color.background.neutral.default};
  border: ${({ theme }) => theme.border.width.thinner} ${({ theme }) => theme.border.style.solid};
  border-color: ${({ theme }) => theme.color.border.neutral.medium};
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.padding.km2} ${({ theme }) => theme.padding.km0};
  box-shadow: 0px 8px 16px rgba(59, 64, 79, 0.18);
  margin-top: ${({ theme }) => theme.spacing.km1};
  position: absolute;
  text-align: left;
  height: fit-content;
  z-index: 1;
`
